"use client";
import { SVGProps } from "react";
import { cn } from "~/utils/fontsConfig";
import { GetWaitlistCommunities } from "../actions";
import SuggestACommunity from "./SuggestACommunity";

type Props = {
    communities: GetWaitlistCommunities;
};

const OKHand = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            {...props}
            width="124"
            height="151"
            viewBox="0 0 124 151"
            fill="none"
            stroke="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M39.8534 129.341V129.341C43.1545 122.267 50.7513 118.245 58.4574 119.492L61.865 120.043C68.5938 121.132 75.4474 119.043 80.4252 114.386L83.3354 111.664C84.367 110.698 85.2867 109.62 86.0771 108.449L93.0613 98.1024C94.5281 95.9293 94.1028 92.9972 92.0789 91.3305V91.3305C90.2132 89.794 87.5238 89.7827 85.6452 91.3035L81.2677 94.8472C80.7593 95.2587 80.2855 95.7112 79.851 96.2L75.8176 100.738C74.7024 101.992 73.3442 103.008 71.8253 103.722L70.4986 104.347C65.1988 106.841 58.9064 104.189 56.9904 98.6538V98.6538"
                stroke={props.stroke}
                strokeWidth="6"
                strokeLinecap="round"
            />
            <path
                d="M56.9904 99.0524L53.4073 88.6017C51.3425 82.5793 53.9866 75.9518 59.63 73.0047L62.0688 71.7311C65.4705 69.9546 69.6241 70.5269 72.4187 73.1571V73.1571C73.8011 74.4581 74.8323 76.0874 75.4166 77.8935L76.4902 81.2118C77.7318 85.0496 82.2082 86.7503 85.6849 84.7052V84.7052V84.7052C88.3824 83.1316 89.4114 79.745 88.0452 76.9367L83.2937 67.1696V67.1696C78.7744 58.131 68.1241 54.0097 58.6977 57.6517L57.7875 58.0034L47.8241 61.9887"
                stroke={props.stroke}
                strokeWidth="6"
                strokeLinecap="round"
            />
            <path
                d="M47.8241 61.9887L79.8004 28.5251C81.2397 27.0188 81.85 24.9032 81.4341 22.8617L81.4135 22.7602C80.687 19.1942 77.0846 16.9958 73.581 17.9806V17.9806C72.6303 18.2478 71.7562 18.7361 71.0301 19.4055L47.7342 40.8841C32.085 55.3125 23.4053 75.7801 23.912 97.0597V97.0597"
                stroke={props.stroke}
                strokeWidth="6"
                strokeLinecap="round"
            />
            <path
                d="M58.186 31.3016L59.7801 25.3236L61.541 18.7201C62.3235 15.7859 60.5346 12.7834 57.5817 12.0747V12.0747C54.9585 11.4452 52.2729 12.8472 51.2899 15.3594L45.8314 29.3089L40.2519 48.4386"
                stroke={props.stroke}
                strokeWidth="6"
                strokeLinecap="round"
            />
            <path
                d="M43.4402 124.16L36.6559 135.264C35.6304 136.942 33.6174 137.738 31.7214 137.215V137.215C24.1054 135.114 17.1938 131.005 11.7097 125.318L9.59864 123.128C7.69108 121.15 7.5293 118.07 9.21913 115.903L23.912 97.0598"
                stroke={props.stroke}
                strokeWidth="6"
                strokeLinecap="round"
            />
            <ellipse
                cx="27.6269"
                cy="11.2554"
                rx="27.6269"
                ry="11.2554"
                transform="matrix(-0.893776 -0.448513 -0.448513 0.893776 59.4807 130.649)"
                fill={props.stroke}
            />
            <path
                d="M29.0244 136.303L32.2308 137.505C32.5447 137.623 32.8975 137.493 33.0594 137.199L36.1485 131.599C38.8705 126.664 42.2742 122.138 46.2592 118.153L47.027 117.385L27.4988 96.6611L8.60714 120.298C8.29272 120.691 8.29535 121.25 8.61347 121.641C13.9984 128.25 21.0422 133.309 29.0244 136.303Z"
                fill="#121418"
            />
            <path
                d="M27.8973 71.1548L32.6798 29.3087L32.9355 27.0072C33.6546 20.5352 42.6272 19.4837 44.8232 25.6141V25.6141C45.2212 26.7252 45.2907 27.9274 45.0234 29.0769L41.4475 44.453"
                stroke={props.stroke}
                strokeWidth="6"
            />
            <path
                d="M103.996 78.7906L112.107 70.2539"
                stroke={props.stroke}
                strokeWidth="6"
                strokeLinecap="round"
            />
            <path
                d="M96.486 76.1204L95.5845 64.3796"
                stroke={props.stroke}
                strokeWidth="6"
                strokeLinecap="round"
            />
            <path
                d="M107.757 85.1201L119.529 84.8189"
                stroke={props.stroke}
                strokeWidth="6"
                strokeLinecap="round"
            />
        </svg>
    );
};

const GreenAsterisk = ({ className }: { className?: string }) => {
    return (
        <svg
            className={className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.9079 0.0550329L24.472 2.64404L18.1356 13.8576L30.5295 10.0843L31.603 16.8764L18.6125 16.6972L28.3401 25.5866L23.1388 29.8231L16.3271 18.5587L13.8714 31.319L7.43892 28.8918L13.7224 17.4522L1.38148 21.4515L0.176268 14.4977L13.1667 14.6768L3.51798 5.72325L8.71926 1.48675L15.3863 12.7345L17.9079 0.0550329Z"
                fill="#198922"
            />
        </svg>
    );
};

const PurpleAsterisk = ({ className }: { className?: string }) => {
    return (
        <svg
            className={className}
            width="44"
            height="45"
            viewBox="0 0 44 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M40.4471 10.3497L43.8128 19.4881L26.3543 23.19L41.6848 32.5341L35.6358 39.8449L23.8513 26.2754L23.6034 44.4323L14.4207 42.9338L19.8165 25.617L4.33102 34.7361L0.919013 25.8813L18.5629 21.9185L3.0471 12.8354L9.14234 5.24094L20.9268 18.8104L21.3138 0.676216L30.4966 2.17479L24.9848 19.3271L40.4471 10.3497Z"
                fill="#CEBDF1"
            />
        </svg>
    );
};

const OtherCommunitiesHero = () => {
    return (
        <>
            <div className="hidden sm:block">
                <div className="relative flex flex-col items-center justify-center gap-8 py-14">
                    <h1 className="max-w-[600px] text-center text-[32px] font-[500] leading-normal text-white">
                        What communities would you like to hang out with on
                        River?
                    </h1>
                    <OKHand
                        className="absolute -left-36 top-0"
                        stroke="#C9E9E9"
                    />
                    <OKHand
                        className="absolute -right-36 rotate-1 scale-x-[-1]"
                        stroke="#D1E350"
                    />
                    <GreenAsterisk className="absolute -left-48 top-5" />
                    <PurpleAsterisk className="absolute -right-48 top-10" />
                </div>
            </div>
            <div className="block sm:hidden">
                <div className="relative flex flex-col items-center justify-center gap-8 py-14">
                    <h1 className="max-w-[600px] text-center text-[24px] font-[500] leading-normal text-white">
                        What communities would you like to hang out with on
                        River?
                    </h1>
                    <OKHand
                        className="absolute -bottom-20 -right-[20%] rotate-1 scale-x-[-1]"
                        stroke="#D1E350"
                    />
                    <GreenAsterisk className="absolute -left-0 bottom-7 sm:top-5" />
                </div>
            </div>
        </>
    );
};

const WhatCommunities = ({ communities }: Props) => {
    return (
        <div className="relative flex h-[300px] w-full flex-col items-center justify-center overflow-hidden px-4 text-white md:h-[400px]">
            <OtherCommunitiesHero />

            {/* Text content */}
            <div className={cn("z-10 flex flex-col items-center text-center")}>
                {/* Buttons */}
                {/* <div className="my-4 flex hidden w-full items-start justify-center sm:block">
                    
                    <HeroButtons userId={userId} />
                   
                </div> */}
                <div>
                    <SuggestACommunity communities={communities} />
                </div>
            </div>
        </div>
    );
};

export default WhatCommunities;
